export const setDaemonsMessage = (text, isReady = 'success', list = null, timeToDefault = true) => {
    return {
        isReady: isReady,
        progress: 100,
        text: text,
        list: list,
        timeToDefault: timeToDefault
    };
};
